class HTMLUpdateUtility {
  static viewTransition(t, e, i = [], a = []) {
    i?.forEach(t => t(e));
    i = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(i, e.outerHTML);
    let r = i.firstChild,
      s = Date.now();
    t.querySelectorAll("[id], [form]").forEach(t => {
      t.id && (t.id = t.id + "-" + s), t.form && t.setAttribute("form", t.form.getAttribute("id") + "-" + s)
    }), t.parentNode.insertBefore(r, t), t.style.display = "none", a?.forEach(t => t(r)), setTimeout(() => t.remove(), 500)
  }
  static setInnerHTML(t, e) {
    t.innerHTML = e, t.querySelectorAll("script").forEach(t => {
      let e = document.createElement("script");
      Array.from(t.attributes).forEach(t => {
        e.setAttribute(t.name, t.value)
      }), e.appendChild(document.createTextNode(t.innerHTML)), t.parentNode.replaceChild(e, t)
    })
  }
}
class QuantityInputDawn extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      bubbles: !0
    }), this.input.addEventListener("change", this.onInputChange.bind(this)), this.querySelectorAll("button").forEach(t => t.addEventListener("click", this.onButtonClick.bind(this)))
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber()
  }
  onInputChange(t) {
    this.validateQtyRules()
  }
  onButtonClick(t) {
    t.preventDefault();
    var e = this.input.value;
    "plus" === t.target.name ? parseInt(this.input.dataset.min) > parseInt(this.input.step) && 0 == this.input.value ? this.input.value = this.input.dataset.min : this.input.stepUp() : this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent), this.input.dataset.min === e && "minus" === t.target.name && (this.input.value = parseInt(this.input.min))
  }
  validateQtyRules() {
    var t, e = parseInt(this.input.value);
    this.input.min && this.querySelector(".quantity__button[name='minus']").classList.toggle("disabled", parseInt(e) <= parseInt(this.input.min)), this.input.max && (t = parseInt(this.input.max), this.querySelector(".quantity__button[name='plus']").classList.toggle("disabled", t <= e))
  }
}
customElements.define("quantity-input-dawn", QuantityInputDawn);
class ProductVariantSelects extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.addEventListener("change", t => {
      var e = this.getInputForEventTarget(t.target);
      this.updateSelectionMetadata(t), publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event: t,
          target: e,
          selectedOptionValues: this.selectedOptionValues
        }
      })
    })
  }
  updateSelectionMetadata({
    target: t
  }) {
    let {
      value: e,
      tagName: i
    } = t;
    var a, r;
    "SELECT" === i && t.selectedOptions.length ? (Array.from(t.options).find(t => t.getAttribute("selected")).removeAttribute("selected"), (r = Array.from(t.options).find(t => t.value === e)) && r.setAttribute("selected", "selected"), r = t.selectedOptions[0].dataset.optionSwatchValue, (a = t.closest(".product-form__input").querySelector("[data-selected-value] > .product-option__swatch")) && (r ? (a.style.setProperty("--swatch--background", r), a.classList.remove("product-option__swatch--unavailable")) : (a.style.setProperty("--swatch--background", "unset"), a.classList.add("product-option__swatch--unavailable")), a.style.setProperty("--swatch-focal-point", t.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"))) : "INPUT" === i && "radio" === t.type && (r = t.closest(".product-form__input").querySelector("[data-selected-value]")) && (r.innerHTML = e)
  }
  getInputForEventTarget(t) {
    return "SELECT" === t.tagName ? t.selectedOptions[0] : t
  }
  get selectedOptionValues() {
    return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(({
      dataset: t
    }) => t.optionValueId)
  }
}
customElements.define("product-variant-selects", ProductVariantSelects), customElements.get("product-info") || customElements.define("product-info", class extends HTMLElement {
  quantityInput = void 0;
  quantityForm = void 0;
  onVariantChangeUnsubscriber = void 0;
  cartUpdateUnsubscriber = void 0;
  abortController = void 0;
  pendingRequestUrl = null;
  preProcessHtmlCallbacks = [];
  postProcessHtmlCallbacks = [];
  constructor() {
    super(), this.quantityInput = this.querySelector(".quantity__input"), this.productMediaGallery = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`), this.productVariantSelects = this.querySelector("product-variant-selects")
  }
  connectedCallback() {
    this.initializeProductSwapUtility(), this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.handleOptionValueChange.bind(this)), this.initQuantityHandlers(), this.dispatchEvent(new CustomEvent("product-info:loaded", {
      bubbles: !0
    })), this.initUpdateMedia(), this.productMediaGallery && "true" === this.productMediaGallery.dataset.hideOtherVariantsMedia && this.updateVariantMedia()
  }
  addPreProcessCallback(t) {
    this.preProcessHtmlCallbacks.push(t)
  }
  initQuantityHandlers() {
    this.quantityInput && (this.quantityForm = this.querySelector(".product-form__quantity"), this.quantityForm) && (this.setQuantityBoundries(), this.dataset.originalSection || (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))))
  }
  initUpdateMedia() {
    var t, e = parseInt(window.location.search.split("?").filter(t => t.includes("variant="))[0]?.split("=")[1]) || null;
    e && (t = this.getSelectedVariant(this)) && e && t?.id === e && this.updateMedia(t?.featured_media?.id)
  }
  disconnectedCallback() {
    this.onVariantChangeUnsubscriber(), this.cartUpdateUnsubscriber?.()
  }
  initializeProductSwapUtility() {
    this.preProcessHtmlCallbacks.push(t => t.querySelectorAll(".scroll-trigger").forEach(t => t.classList.add("scroll-trigger--cancel"))), this.postProcessHtmlCallbacks.push(t => {
      window?.Shopify?.PaymentButton?.init(), window?.ProductModel?.loadShopifyXR()
    })
  }
  handleOptionValueChange({
    data: {
      event: t,
      target: e,
      selectedOptionValues: i
    }
  }) {
    var a, r;
    this.contains(t.target) && (this.resetProductFormState(), t = e.dataset.productUrl || this.pendingRequestUrl || this.dataset.url, this.pendingRequestUrl = t, a = this.dataset.url !== t, r = "true" === this.dataset.updateUrl && a, this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(t, i, r),
      targetId: e.id,
      callback: a ? this.handleSwapProduct(t, r) : this.handleUpdateProductInfo(t)
    }))
  }
  resetProductFormState() {
    var t = this.productForm;
    t?.toggleSubmitButton(!0), t?.handleErrorMessage()
  }
  handleSwapProduct(i, a) {
    return t => {
      this.productModal?.remove();
      var e = this.getSelectedVariant(t.querySelector(a ? "product-info[id^='MainProduct']" : "product-info"));
      this.updateURL(i, e?.id), a ? (document.querySelector("head title").innerHTML = t.querySelector("head title").innerHTML, HTMLUpdateUtility.viewTransition(document.querySelector("main"), t.querySelector("main"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)) : HTMLUpdateUtility.viewTransition(this, t.querySelector("product-info"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)
    }
  }
  renderProductInfo({
    requestUrl: t,
    targetId: e,
    callback: i
  }) {
    this.abortController?.abort(), this.abortController = new AbortController, fetch(t, {
      signal: this.abortController.signal
    }).then(t => t.text()).then(t => {
      this.pendingRequestUrl = null;
      t = (new DOMParser).parseFromString(t, "text/html");
      i(t)
    }).then(() => {
      document.querySelector("#" + e)?.focus()
    }).catch(t => {
      t.name
    })
  }
  getSelectedVariant(t) {
    t = t.querySelector("product-variant-selects [data-selected-variant]")?.innerHTML;
    return t ? JSON.parse(t) : null
  }
  buildRequestUrlWithParams(t, e, i = !1) {
    var a = [];
    return i || a.push("section_id=" + this.sectionId), e.length && a.push("option_values=" + e.join(",")), t + "?" + a.join("&")
  }
  updateOptionValues(t) {
    t = t.querySelector("product-variant-selects");
    t && HTMLUpdateUtility.viewTransition(this.variantSelectors, t, this.preProcessHtmlCallbacks)
  }
  handleUpdateProductInfo(i) {
    return s => {
      var t, e = this.getSelectedVariant(s);
      this.updateOptionValues(s), this.updateURL(i, e?.id), this.updateVariantInputs(e?.id), this.updateVariantDiscountBadge(e?.price, e?.compare_at_price), this.updateVariantDetails(e?.id), this.pickupAvailability && e?.id && (this.pickupAvailability.dataset.variantId = e.id, this.pickupAvailability.fetchAvailability(e.id)), this.productMediaGallery && "true" === this.productMediaGallery.dataset.hideOtherVariantsMedia && this.updateVariantMedia(s), e ? (this.updateMedia(e?.featured_media?.id), (t = (t, e = t => !1) => {
        var i, a = s.getElementById(t + "-" + this.sectionId),
          r = this.querySelector(`#${t}-` + this.dataset.section);
        a && r && (r.innerHTML = a.innerHTML, "Inventory" === t ? (t = parseInt(a.dataset.inventoryThreshold), i = parseInt(a.dataset.inventoryQuantity), r.classList.toggle("hidden", t && t < i || i < 1)) : r.classList.toggle("hidden", e(a)))
      })("ProductPurchaseInfo"), t("ProductStickyCart"), t("price"), t("Sku", ({
        classList: t
      }) => t.contains("hidden")), t("Inventory", ({
        innerText: t
      }) => "" === t), this.updateQuantityRules(this.sectionId, s), this.querySelector("#Quantity-Rules-" + this.dataset.section)?.classList.remove("hidden"), this.productForm?.toggleSubmitButton(s.getElementById("ProductSubmitButton-" + this.sectionId)?.hasAttribute("disabled") ?? !0, window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: this.sectionId,
          html: s,
          variant: e
        }
      })) : this.setUnavailable()
    }
  }
  updateVariantMedia() {
    var t = this.querySelector("product-variant-selects [data-selected-variant-options-handle]")?.innerHTML.trim();
    if (!t) {
      let i = this.productVariantSelects.querySelector("[data-all-variants]").innerHTML.trim();
      this.productVariantSelects.addEventListener("click", t => {
        t = t.target.closest(".product-option__input");
        if (t) {
          let e = t.value;
          JSON.parse(i).find(t => t.options.some(t => t === e))
        }
      })
    }
    this.productMediaGallery.querySelectorAll("[data-media-group]").forEach(t => t.classList.add("hidden")), this.productMediaGallery.querySelectorAll(`[data-media-group="${t}"]`).forEach(t => t.classList.remove("hidden")), this.productMediaGallery.querySelectorAll("swiper-product-gallery").forEach(t => {
      t.instance ? t.instance.update() : t.init()
    })
  }
  updateVariantOptionMedia() {
    this.productMediaGallery.querySelectorAll("[data-media-group]:not(.hidden)").forEach(t => {})
  }
  updateVariantInputs(e) {
    this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-` + this.dataset.section).forEach(t => {
      t = t.querySelector('input[name="id"]');
      t.value = e ?? "", t.dispatchEvent(new Event("change", {
        bubbles: !0
      }))
    })
  }
  updateURL(t, e) {
    this.querySelector("share-button")?.updateUrl("" + window.shopUrl + t + (e ? "?variant=" + e : "")), "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", t + (e ? "?variant=" + e : ""))
  }
  updateSellingPlanURL(t, e) {
    var i;
    e && (t ? ((i = new URLSearchParams(window.location.search))[i.has("variant") ? "set" : "append"]("variant", e), t ? i[i.has("selling_plan") ? "set" : "append"]("selling_plan", t) : i.delete("selling_plan"), window.history.replaceState({}, "", this.dataset.url + "?" + i.toString())) : window.history.replaceState({}, "", "" + window.location.href.replace(/&selling_plan=\d+/, "")))
  }
  updateVariantDetails(a) {
    var t = this.querySelectorAll(".product__metafield_for_variant-block");
    t && t.forEach(t => {
      var e = t.getAttribute("data-block-id"),
        e = this.querySelector("#product__metafield_for_variant-block--" + e);
      if (e) try {
        var i = JSON.parse(e?.textContent);
        t.innerHTML = i?.[a]?.replaceAll("\n", "<br />") || ""
      } catch (t) {
        console.error("Error parsing JSON", t)
      }
    })
  }
  updateVariantDiscountBadge(t, e) {
    var i, a = this.querySelector(".product-card__badge--discount");
    a && (t < e ? (a.classList.remove("hidden"), i = a.querySelector(".percentage"), t = Math.round((e - t) / e * 100), i.textContent = t) : a.classList.add("hidden"))
  }
  setUnavailable() {
    this.productForm?.toggleSubmitButton(!0, window.variantStrings.unavailable);
    var t = ["price", "Inventory", "Sku", "Quantity-Rules"].map(t => `#${t}-` + this.dataset.section).join(", ");
    document.querySelectorAll(t).forEach(({
      classList: t
    }) => t.add("hidden"))
  }
  updateMedia(t) {
    var e;
    t && ((e = this.querySelector(".main-product__media--grid")) && (e.querySelectorAll(".swiper-slide").forEach(t => {
      t.classList.remove("active")
    }), e = e.querySelector(`.swiper-slide[data-media-id="${t}"]`)) && e.classList.add("active"), this.querySelector(".main-product__media")?.hasAttribute("data-desktop-grid") && 750 <= window.innerWidth && this.scrollToImage(t), this.querySelector("swiper-product-gallery")?.setActiveMedia(t))
  }
  scrollToImage(e) {
    this.querySelectorAll("[data-media-id]").forEach(t => {
      t.getAttribute("data-media-id") == e && t.scrollIntoView({
        block: "end",
        behavior: "smooth"
      })
    })
  }
  setQuantityBoundries() {
    var t = {
      cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
      min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
      max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
      step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1
    };
    let e = t.min;
    var i = null === t.max ? t.max : t.max - t.cartQuantity;
    null !== i && (e = Math.min(e, i)), t.min <= t.cartQuantity && (e = Math.min(e, t.step)), this.quantityInput.min = e, i ? this.quantityInput.max = i : this.quantityInput.removeAttribute("max"), this.quantityInput.value = e, publish(PUB_SUB_EVENTS.quantityUpdate, void 0)
  }
  fetchQuantityRules() {
    var t = this.productForm?.variantIdInput?.value;
    t && (this.querySelector(".quantity__rules-cart .loading__spinner").classList.remove("hidden"), fetch(this.dataset.url + `?variant=${t}&section_id=` + this.dataset.section).then(t => t.text()).then(t => {
      t = (new DOMParser).parseFromString(t, "text/html");
      this.updateQuantityRules(this.dataset.section, t)
    }).catch(t => console.error(t)).finally(() => this.querySelector(".quantity__rules-cart .loading__spinner").classList.add("hidden")))
  }
  updateQuantityRules(t, e) {
    if (this.quantityInput) {
      this.setQuantityBoundries();
      var i, a = e.getElementById("Quantity-Form-" + t);
      for (i of [".quantity__input", ".quantity__rules", ".quantity__label"]) {
        var r, s = this.quantityForm.querySelector(i),
          n = a.querySelector(i);
        if (s && n)
          if (".quantity__input" === i)
            for (r of ["data-cart-quantity", "data-min", "data-max", "step"]) {
              var o = n.getAttribute(r);
              null !== o ? s.setAttribute(r, o) : s.removeAttribute(r)
            } else s.innerHTML = n.innerHTML
      }
    }
  }
  get productForm() {
    return this.querySelector("product-form")
  }
  get productModal() {
    return document.querySelector("#ProductModal-" + this.dataset.section)
  }
  get pickupAvailability() {
    return this.querySelector("pickup-availability")
  }
  get variantSelectors() {
    return this.querySelector("product-variant-selects")
  }
  get relatedProducts() {
    var t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "related-products");
    return document.querySelector(`product-recommendations[data-section-id^="${t}"]`)
  }
  get quickOrderList() {
    var t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "quick_order_list");
    return document.querySelector(`quick-order-list[data-id^="${t}"]`)
  }
  get sectionId() {
    return this.dataset.originalSection || this.dataset.section
  }
}), customElements.get("product-form") || customElements.define("product-form", class extends HTMLElement {
  constructor() {
    super(), this.form = this.querySelector("form"), this.variantIdInput.disabled = !1, this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer"), this.submitButton = this.querySelector('[type="submit"]'), this.submitButtonText = this.submitButton.querySelector("span"), document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"), this.hideErrors = "true" === this.dataset.hideErrors
  }
  onSubmitHandler(t) {
    if (t.preventDefault(), "true" !== this.submitButton.getAttribute("aria-disabled")) {
      this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.classList.add("loading"), this.querySelector(".loading__spinner").classList.remove("hidden");
      t = fetchConfig("javascript");
      t.headers["X-Requested-With"] = "XMLHttpRequest", delete t.headers["Content-Type"];
      let i = new FormData(this.form);
      this.cart && (i.append("sections", this.cart.getSectionsToRender().map(t => t.section)), i.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement)), t.body = i, fetch("" + routes.cart_add_url, t).then(t => t.json()).then(t => {
        var e;
        if (t.status) return publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: i.get("id"),
          errors: t.errors || t.description,
          message: t.message
        }), this.handleErrorMessage(t.description), (e = this.submitButton.querySelector(".sold-out-message")) ? (this.submitButton.setAttribute("aria-disabled", !0), this.submitButtonText.classList.add("hidden"), e.classList.remove("hidden"), void(this.error = !0)) : void 0;
        this.cart ? (this.error || publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: i.get("id"),
          cartData: t
        }), this.error = !1, this.cart.renderContents(t)) : window.location = window.routes.cart_url
      }).catch(t => {
        console.error(t)
      }).finally(() => {
        this.submitButton.classList.remove("loading"), this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"), this.error || this.submitButton.removeAttribute("aria-disabled"), this.querySelector(".loading__spinner").classList.add("hidden")
      })
    }
  }
  handleErrorMessage(t = !1) {
    this.hideErrors || (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper"), this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !t), t) && (this.errorMessage.textContent = t))
  }
  toggleSubmitButton(t = !0, e) {
    t ? (this.submitButton.setAttribute("disabled", "disabled"), e && (this.submitButtonText.textContent = e)) : (this.submitButton.removeAttribute("disabled"), this.submitButtonText.textContent = this.hasAttribute("data-has-selling-plan") ? window.variantStrings.addSubscriptionToCart : this.submitButtonText.textContent = this.hasAttribute("data-has-pre-order") ? window.variantStrings.preOrder : window.variantStrings.addToCart)
  }
  get variantIdInput() {
    return this.form.querySelector("[name=id]")
  }
}), document.querySelectorAll(".product__content > *").forEach(t => {
  t.textContent.trim() || (t.textContent = "")
});